exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Spinner-module__spinner___117kO{display:inline-block}.Spinner-module__spinner___117kO.Spinner-module__full-page___2y2UF{width:100%;height:100%;color:#0827e9;font-size:50px;display:flex;justify-content:center;align-items:center}", ""]);

// exports
exports.locals = {
	"spinner": "Spinner-module__spinner___117kO",
	"full-page": "Spinner-module__full-page___2y2UF"
};